// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"192":"f08075fd","541":"48f8e024","767":"e823892d"}[chunkId] + ".chunk.css";
};